import { useState } from 'react';
import { baseUrl, getMuid } from '../../../lib/utils.esm.js';

const useCreateClient = () => {
  const [status, setStatus] = useState('idle');
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const createClient = async clientData => {
    setStatus('pending');
    setError(null);
    try {
      const response = await fetch(`${baseUrl}${window.apiV6Config.path}/b2b/client?muid=${getMuid()}&locale=${window.dataGlobalSettings?.locale || 'en'}`, {
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify(clientData)
      });
      if (response.status === 400) {
        const res = await response.json();
        setError(res.errors);
      } else {
        const result = await response.json();
        setData(result);
        setStatus('success');
        return result;
      }
    } catch (err) {
      setError(err.message);
      setStatus('error');
      return null;
    }
  };
  return {
    createClient,
    status,
    data,
    error
  };
};

export { useCreateClient };
//# sourceMappingURL=useCreateClient.esm.js.map
